// extracted by mini-css-extract-plugin
export var actionGuide = "ActionGuide-module--actionGuide--ZDreb";
export var container = "ActionGuide-module--container--mtzE1";
export var content = "ActionGuide-module--content--pSuuR";